import { useStyles } from '@team-griffin/stylr';
import { useBreakpoints, breakpoints as breakpointsValues } from '@ux/responsive';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px, useTheme } from '@uds/theme-utils';
import ribbonPadding from 'presentation/utils/ribbonPadding';
import { Layout } from 'domain/constants/layout';
import { Alignment } from 'domain/constants/alignment';
import { modifier } from '@ux/style-utils';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';

import { Side as TilesSide } from '../constants';
import { getActiveAnchor, halfContainerWidth } from '../styles';

export default ({ layout }: { layout: Layout }) => {
  const { theme } = useTheme();
  const { spacing } = theme;
  const breakpoints = useBreakpoints();
  const { isMinSm, isMinLg, isMinXl } = breakpoints;

  const alignment = findResponsiveItem(breakpoints, [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  const { anchor, tilesSide } = layout;
  // @ts-ignore: error after upgrading to ux-configs
  const activeAnchor = getActiveAnchor(anchor, breakpoints);

  return useStyles(
    {
      default: {
        container: {
          ...cssSides('padding', Side.X, gu2px(1, spacing)),
        },
        // @ts-ignore: error after upgrading to ux-configs
        content: {
          flex: 1,
          flexBasis: 'auto',
          justifyContent: activeAnchor,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          ...ribbonPadding({
            spacing,
            isMinSm,
            isMinLg,
          }),
        },
        body: {
          flex: 1,
          flexBasis: 'auto',
        },
      },

      isMinLg: {
        container: {
          display: 'flex',
          flex: 1,
          flexBasis: 'auto',
          // Safari is not filling 100% height of flex parent
          // in nested flex containers
          webkitFlexBasis: 0,
          width: '100%',
          maxWidth: '100%',
        },
        row: {
          width: '100%',
        },
        content: {
          marginLeft: 'auto',
          maxWidth: halfContainerWidth(breakpointsValues.lg, spacing),
          height: '100%',
          position: 'static',
        },
      },

      isMinXl: {
        content: {
          maxWidth: halfContainerWidth(breakpointsValues.xl, spacing),
        },
      },

      lgStartTile: {
        content: {
          marginLeft: 0,
          marginRight: 'auto',
        },
      },

      [modifier('alignment', Alignment.CENTER)]: {
        content: {
          textAlign: 'center',
        },
      },
    },
    [
      { isMinSm },
      { isMinLg },
      { isMinXl },
      { lgStartTile: tilesSide === TilesSide.START && isMinLg },
      { alignment },
      { activeAnchor },
    ],
  );
};
